import { FinanceRuleSeverity } from '../../../types/contract.types';
import { ContractTypeId } from '../../../services/api/ruleService';

export const SEVERITY_OPTIONS: { value: FinanceRuleSeverity; label: string; description: string }[] = [
  { value: 'CRITICAL', label: 'Critical', description: 'do not sign as is' },
  { value: 'HIGH_RISK', label: 'High risk', description: 'must be renegotiated' },
  { value: 'NEGOTIATE', label: 'Negotiate', description: 'push back if possible' }
];

const TYPE_LABELS: Partial<Record<ContractTypeId, string>> = {
  nda: 'NDA',
  saas: 'SaaS'
};

export const contractTypeLabel = (type: ContractTypeId): string =>
  TYPE_LABELS[type] || type.charAt(0).toUpperCase() + type.slice(1);

export const personName = (u?: { firstName?: string; lastName?: string; email?: string }): string =>
  u ? [u.firstName, u.lastName].filter(Boolean).join(' ') || u.email || 'Unknown' : 'Unknown';

export const CLASSIFICATION_LABELS = {
  ACCEPTABLE: 'Acceptable',
  NEGOTIATE: 'Negotiate',
  HIGH_RISK: 'High risk',
  CRITICAL: 'Critical'
} as const;

export const TIER_LABELS: Record<1 | 2 | 3 | 4, string> = {
  1: 'Economic continuity',
  2: 'Performance balance',
  3: 'Liability protection',
  4: 'Operating flexibility'
};

export const unitLabel = (unit?: string): string =>
  unit === 'percent' ? '%' : unit === 'count' ? '' : unit || '';
